import { userConstants } from "../../constants/ActionTypes";

const initialState = {
  showQuickTransfer: false,
  contactList: [],
  page: 1,
  limit: 30,
  add_new_contact: false,
  selectContact: false,
  selectedSingleContact: {},
  addingPayout: false,
  confirmCreationPayout: false,
  drop_down_open: false,
  FundAcntList: [],
  selectedFundAcntList: {},
  FundAcntUpiList: [],
  selectedFundAcntUpiList: {},
  account_type: "bank_acnt",
  account_type_list: "bank_acnt",
  ShowFundAcntList: false,
  ShowFundAcntUpiList: false,
  contact_id: "",
  beneficiary_id: "",
  payoutRequest: [],
  contact_name: "",
  phone: "",
  email: "",
  contact_type: "",
  fund_account_list: [],
  back_stage: false,
  remove_stage: false,
  itemSearchTerm: "",
  totalPage: 0,
  open_picker: false,
  startDate: new Date(),
  endDate: new Date(),
  from: "",
  to: "",
  fromDate: "",
  toDate: "",
  searchTerm: "",
  filterList: false,
  contactDetail: {},
  modalIsOpen: false,
  transactionDetails: {},
  showContactList: true,
  payment_type: "",
  transaction_ref: "",
  payout_verify_otp: "",
  showPayout: false,
  disabled_page: true,
  quick_transfer: false,
  van_account_no: "",
  showUPIFundList: false,
  createUPIFundAcnt: false,
  showSavedAccounts: false,
  selectBankAccount: false,
};

export function payout_request(state = initialState, action) {
  switch (action.type) {
    case userConstants.PAYOUT_REQUEST:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
